import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-16 px-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white" data-id="element-34">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-35">
        <SparklesIcon className="h-12 w-12 mx-auto mb-6" data-id="element-36" />
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-37">
          Hoy puede ser el inicio de tu nueva vida
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-38">
          Haz clic abajo. Accede al contenido completo. Y empieza a construir tu
          negocio de uñas profesional desde casa.
        </p>
        <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-white text-pink-600 px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 inline-block" data-id="element-39">
          ACCEDER AHORA - $14.999
        </a>
      </div>
    </section>;
}